import { reduce } from 'lodash';

const HostMap = {
  USERCENTER: '/ucenter/',
  USERCENTERDEV: '/ucenter-dev/',
  SUPPLIER: '/scc/',
  CAISX_SETTLE: '/gss/',
  TASKCENTER: '/',
  MESSAGECENTER: '/',
  DEVOPS: '/',
  CAISX_MDM: '/mdm/',
  SCM: '/scm/',
  MALIANG: '/maliang1/',
  NOT: '/',
  SYSTEM: '/system/',
  FQS: '/fqs/',
  FQSAPP: '/fqs-app/',
};
const hostWapi = process.env.CSX_FE_SCC_DEVOPS_HOST_TEST || 'https://wapi.freshfood.cn';
const getBaseUrl = function () {
  return reduce(
    HostMap,
    (prev, val, key) => {
      if (key === 'DEVOPS') {
        return { ...prev, [key]: hostWapi + val };
      }
      return { ...prev, [key]: process.env.CSX_FE_PUBLIC_WAPI_HOST + val };
    },
    {},
  );
};

export default getBaseUrl();
